import { Elem, Txt } from 'modapp-base-component';
import { ModelTxt, ModelComponent } from 'modapp-resource-component';
import Collapser from 'components/Collapser';
import Img from 'components/Img';
import renderingModes from 'utils/renderingModes';
import l10n from 'modapp-l10n';
import RealmTagsList, { hasTags } from 'components/RealmTagsList';
import { redirect } from 'utils/reload';
import FormatTxt from 'components/FormatTxt';
import SimpleBar from 'components/SimpleBar';

const realmLoginPath = REALM_LOGIN_PATH;

function formatNumber(n) {
	if (typeof n != 'number') {
		return "?";
	}
	let s = String(n);
	for (let i = s.length - 3; i > 0; i -= 3) {
		s = s.slice(0, i) + ' ' + s.slice(i);
	}
	return s;
}

function addCounters(n, realm) {
	return [
		n.elem('div', { className: 'realmlist-realm--counter' }, [
			n.elem('span', { className: 'realmlist-realm--dot highlight' }),
			n.component(new ModelTxt(realm.population, m => l10n.l('realmList.countAwake', "{count} Awake", { count: formatNumber(m?.awakeChars) }), {
				duration: 0,
			})),
		]),
		n.elem('div', { className: 'realmlist-realm--counter' }, [
			n.elem('span', { className: 'realmlist-realm--dot' }),
			n.component(new ModelTxt(realm.population, m => l10n.l('realmList.countCharacters', "{count} Characters", { count: formatNumber(m?.totalChars) }), {
				duration: 0,
			})),
		]),
	];
}

/**
 * RealmListComponent draws the list of realms.
 */
class RealmListComponent {
	constructor(module, model, realm) {
		this.module = module;
		this.model = model;
		this.realm = realm;
	}

	render(el) {
		this.elem = new ModelComponent(
			this.model,
			new Elem(n => n.elem('div', {
				className: 'realmlist-realm',
			}, [
				n.elem('div', {
					className: 'realmlist-realm--cont',
					events: {
						click: (c, ev) => {
							// Toggle realmId
							this.model.set({ realmId: (this.model.realmId != this.realm?.id && this.realm?.id) || null });
							ev.stopPropagation();
						},
					},
				}, [

					// Image
					n.component(new ModelComponent(
						this.realm,
						new Img('', { className: 'realmlist-realm--img' }),
						(m, c, changed) => {
							c.setSrc(m?.image ? m.image.href + '?thumb=mw' : '/img/realm-placeholder.svg');
							c[m?.image ? 'removeClass' : 'addClass']('placeholder');
							for (let mode of renderingModes) {
								if (mode.className) {
									c[m?.image?.rendering == mode.key ? 'addClass' : 'removeClass'](mode.className);
								}
							}
						},
					)),

					// n.elem('img', { attributes: { src: '/img/realm1.png' }, className: 'realmlist-realm--img' }),
					n.elem('div', { className: 'realmlist-realm--header' }, [

						// Icon
						n.component(new ModelComponent(
							this.realm,
							new Img('', { className: 'realmlist-realm--icon' }),
							(m, c, changed) => {
								c.setSrc(m?.icon ? m.icon.href + '?thumb=xxl' : '/img/realmicon-placeholder.svg');
								c[m?.icon ? 'removeClass' : 'addClass']('placeholder');
								for (let mode of renderingModes) {
									if (mode.className) {
										c[m?.icon?.rendering == mode.key ? 'addClass' : 'removeClass'](mode.className);
									}
								}
							},
						)),

						n.elem('div', { className: 'realmlist-realm--title-cont' }, [

							// Title
							n.elem('span', { className: 'realmlist-realm--title' }, [
								n.component(new ModelTxt(this.realm, m => m?.name || '')),
							]),

							// Counters on mobile devices
							n.elem('div', { className: 'realmlist-realm--counters-top' }, addCounters(n, this.realm)),
						]),
					]),

					// Tags
					// Only show tags if there is at least one valid tag.
					n.component(new ModelComponent(
						this.realm?.tags,
						new Collapser(),
						(m, c) => c.setComponent(hasTags(m)
							? c.getComponent() || new RealmTagsList(m, { className: 'realmlist-realm--tags', static: true })
							: null,
						),
					)),

					// Description
					n.elem('div', { className: 'realmlist-realm--desktop realmlist-realm--desc' }, [
						n.component(new SimpleBar(
							new ModelComponent(
								this.realm,
								new FormatTxt("", { className: 'common--desc-size', mode: 'default' }),
								(m, c) => c.setFormatText(m.desc),
							),
							{
								autoHide: false,
								className: 'realmlist-realm--descsb',
							},
						)),
					]),

					n.elem('div', { className: 'realmlist-realm--desktop realmlist-realm--footer' }, [

						// Counters on desktops
						n.elem('div', { className: 'realmlist-realm--counters' }, addCounters(n, this.realm)),

						// Enter button
						n.component(new ModelComponent(
							this.realm,
							new Elem(n => n.elem('a', {
								className: 'realmlist-realm--signin btn primary icon-center',
								events: {
									click: (c, ev) => {
										this._onEnter();
										ev.stopPropagation();
									},
								},
							}, [
								n.component(new Txt('Enter')),
								n.elem('i', { className: 'fa fa-sign-in' }),
							])),
							(m, c) => c.setAttribute('href', this.realm.clientUrl.replace(/\/$/g, '') + '/' + realmLoginPath.replace(/^\//g, '')),
						)),
					]),
				]),

				// Mobile description
				n.component('mobile', new Collapser(null, { className: 'realmlist-realm--mobile' })),

				// // Caret on mobile devices
				// n.elem('div', { className: 'realmlist-realm--caret' }, [
				// 	n.elem('i', { className: 'fa fa-angle-down' }),
				// ]),
			])),
			(m, c) => {
				let isActive = this.model.realmId == this.realm?.id;
				c[isActive ? 'addClass' : 'removeClass']('active');
				let collapser = c.getNode('mobile');
				collapser.setComponent(isActive
					? collapser.getComponent() || new Elem(n => n.elem('div', { className: 'realmlist-realm--content' }, [
						n.elem('div', { className: 'realmlist-realm--desc' }, [
							n.component(new ModelComponent(
								this.realm,
								new FormatTxt("", { className: 'common--desc-size', mode: 'default' }),
								(m, c) => c.setFormatText(m.desc),
							)),
						]),

						n.elem('div', { className: 'realmlist-realm--footer' }, [
							// Enter button
							n.elem('button', {
								className: 'realmlist-realm--signin btn primary',
								events: {
									click: (c, ev) => {
										this._onEnter();
										ev.stopPropagation();
									},
								},
							}, [
								n.component(new Txt(l10n.l('realmList.enter', "Enter"))),
								n.elem('i', { className: 'fa fa-sign-in' }),
							]),
						]),
					]))
					: null,
				);
			},
		);
		return this.elem.render(el);
	}

	unrender() {
		this.elem?.unrender();
		this.elem = null;
	}

	_onEnter() {
		let url = this.realm.clientUrl.replace(/\/$/g, '') + '/' + realmLoginPath.replace(/^\//g, '');
		redirect(url, false, true);
	}
}

export default RealmListComponent;
